import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-15787ec6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "detail"
};
var _hoisted_2 = {
  class: "top"
};
var _hoisted_3 = {
  class: "title"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode(" 开会时间：");

var _hoisted_5 = {
  class: "bolder"
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode(" - ");

var _hoisted_7 = {
  class: "content"
};
var _hoisted_8 = {
  class: "space"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "header"
  }, "活动地址: ", -1);
});

var _hoisted_10 = {
  class: "space"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "header"
  }, "活动类型: ", -1);
});

var _hoisted_12 = {
  key: 0
};
var _hoisted_13 = {
  key: 1
};
var _hoisted_14 = {
  class: "space"
};

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "header"
  }, "发起组织: ", -1);
});

var _hoisted_16 = {
  class: "space"
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "header"
  }, "发起人: ", -1);
});

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "header space"
  }, " 活动简介: ", -1);
});

var _hoisted_19 = ["innerHTML"];

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "header space"
  }, " 活动记实: ", -1);
});

var _hoisted_21 = {
  key: 0
};
var _hoisted_22 = ["innerHTML"];
var _hoisted_23 = {
  key: 0,
  class: "imgUrl"
};
var _hoisted_24 = ["src"];
var _hoisted_25 = {
  key: 1
};

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "header space"
  }, " 附件: ", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.detail.title), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "time"
  }, {
    default: _withCtx(function () {
      return [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(_ctx.detail.startTime), 1), _hoisted_6, _createElementVNode("span", null, _toDisplayString(_ctx.detail.endTime), 1)])];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_row, {
    class: "b-btm"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createTextVNode(" " + _toDisplayString(_ctx.detail.address), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _ctx.detail.typeName ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.detail.typeName), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_13, "未知"))]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createTextVNode(" " + _toDisplayString(_ctx.detail.originatorOrgName), 1)]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createTextVNode(" " + _toDisplayString(_ctx.detail.originatorName), 1)])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_row, {
    style: {
      "padding-top": "13px"
    },
    class: "b-btm"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_hoisted_18, _createElementVNode("div", {
            class: "space",
            innerHTML: _ctx.detail.description
          }, null, 8, _hoisted_19)];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_row, {
    style: {
      "padding-top": "13px"
    },
    class: "b-btm"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_hoisted_20, _ctx.detail.content ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", {
            class: "space",
            innerHTML: _ctx.detail.content
          }, null, 8, _hoisted_22), _ctx.detail.imgUrl ? (_openBlock(), _createElementBlock("div", _hoisted_23, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.imgUrl.split(','), function (item, index) {
            return _openBlock(), _createElementBlock("img", {
              key: index,
              src: _ctx.baseurl + item
            }, null, 8, _hoisted_24);
          }), 128))])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_25, " 无 "))];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_row, {
    style: {
      "padding-top": "13px"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 24
      }, {
        default: _withCtx(function () {
          return [_hoisted_26, _withDirectives(_createElementVNode("div", {
            style: {
              "cursor": "pointer"
            },
            class: "space down",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.$emit('downFile');
            })
          }, _toDisplayString(_ctx.showAttachment), 513), [[_vShow, _ctx.showAttachment != '暂无附件']]), _withDirectives(_createElementVNode("div", {
            class: "space"
          }, _toDisplayString(_ctx.showAttachment), 513), [[_vShow, _ctx.showAttachment == '暂无附件']])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _renderSlot(_ctx.$slots, "other", {}, undefined, true)])]);
}